export default __webpack_public_path__ + "static/media/img1.11cb4713.jpeg";